// This file is automatically generated. Do not edit manually.

import { CustomerOrderOfferState } from "src/api/generated/erp/db/types/enums/customerOrderOfferState";
import { ServerSideDataModelRequest } from "src/api/generated/common/dataGrids/serverSideDataModelRequest";
import { ServerSideDataModelResult } from "src/api/generated/common/dataGrids/serverSideDataModelResult";
import { IsoDateTimeString } from "src/types/dateTime";
import { IsoDateString } from "src/types/dateTime";
import { CustomerPriceGroupPricingMethod } from "src/api/generated/io/aavo/applications/db/erp/types/customerPriceGroupPricingMethod";
import { CustomerType } from "src/api/generated/erp/db/types/enums/customerType";
import { Country } from "src/api/generated/io/aavo/applications/db/erp/types/country";
import { CustomerOrderOfferViewPriceRecalculationStatus } from "src/api/generated/erp/db/types/enums/customerOrderOfferViewPriceRecalculationStatus";
import { SalespersonPaymentMethod } from "src/api/generated/erp/db/types/enums/salespersonPaymentMethod";
import { makeAxiosRequest } from "src/api/utils/apiClient";

export namespace CustomerOrderOfferDataGridApi {
	export async function getCustomerOrderOffers(args: {
		searchQuery: string;
		showOnlyDefaultSiteOffers: boolean;
		stateFilter?: Array<CustomerOrderOfferState>;
		showDiscardedOffers?: boolean;
		showOrderedOffers?: boolean;
		showLostOffers?: boolean;
		showCancelledOffers?: boolean;
		salesLeadId?: number | null | undefined;
		customerId?: number | null | undefined;
		customerOfferTypeIds?: Array<number>;
		dataModelRequest: ServerSideDataModelRequest;
	}): Promise<ServerSideDataModelResult<CustomerOrderOfferDataGridApi_CustomerOrderOfferDto>> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/sales/customerOrderOffer/getCustomerOrderOffers",
			method: "POST",
			data: {
				searchQuery: args.searchQuery,
				showOnlyDefaultSiteOffers: args.showOnlyDefaultSiteOffers,
				stateFilter: args.stateFilter,
				showDiscardedOffers: args.showDiscardedOffers,
				showOrderedOffers: args.showOrderedOffers,
				showLostOffers: args.showLostOffers,
				showCancelledOffers: args.showCancelledOffers,
				salesLeadId: args.salesLeadId,
				customerId: args.customerId,
				customerOfferTypeIds: args.customerOfferTypeIds,
				dataModelRequest: args.dataModelRequest,
			},
		});
		return response as ServerSideDataModelResult<CustomerOrderOfferDataGridApi_CustomerOrderOfferDto>;
	}
}

export interface CustomerOrderOfferDataGridApi_CustomerOrderOfferDto {
	billingPlanIsComplete: boolean;
	additionalAddress: string;
	billingPlanEnabled: boolean;
	cancelledAt: IsoDateTimeString | null | undefined;
	closedAt: IsoDateTimeString | null | undefined;
	contactEmail: string;
	contactName: string;
	contactPhone: string;
	contractDate: IsoDateString | null | undefined;
	contractualTermCode: string | null | undefined;
	contractualTermContent: string | null | undefined;
	contractualTermId: number | null | undefined;
	createdAt: IsoDateTimeString;
	createdBy: string;
	createdByUserId: number;
	currencyCode: string;
	currencyId: number;
	customerBusinessId: string | null | undefined;
	customerGroupName: string | null | undefined;
	customerId: number;
	customerName: string;
	customerOfferRequestNo: string;
	customerOfferTypeId: number | null | undefined;
	customerOfferTypeName: string | null | undefined;
	customerOrderCreatedAt: IsoDateTimeString | null | undefined;
	customerOrderId: number | null | undefined;
	customerOrderOfferId: number;
	customerOrderOfferLastUpdated: IsoDateTimeString;
	customerOrderOfferLongName: string | null | undefined;
	customerOrderOfferState: CustomerOrderOfferState;
	customerPriceGroupId: number | null | undefined;
	customerPriceGroupPricingMethod: CustomerPriceGroupPricingMethod;
	customerType: CustomerType;
	deliveryAddress_1: string;
	deliveryAddress_2: string;
	deliveryCity: string;
	deliveryContact: string | null | undefined;
	deliveryCountry: Country;
	deliveryDurationDays: number | null | undefined;
	deliveryMethodCode: string;
	deliveryMethodId: number;
	deliveryName: string;
	deliveryPostalCode: string;
	deliveryRecipientName: string;
	deliveryTermsCode: string;
	deliveryTermsDestination: string;
	deliveryTermsId: number;
	discardedAt: IsoDateTimeString | null | undefined;
	domesticCurrencyCode: string;
	domesticCurrencyId: number;
	externalContractId: string | null | undefined;
	externalOrderId: string | null | undefined;
	frozen: boolean;
	inputPricesWithVat: boolean;
	invoiceAddressAddress_1: string;
	invoiceAddressAddress_2: string;
	invoiceAddressCity: string;
	invoiceAddressCountry: Country;
	invoiceAddressEmail: string | null | undefined;
	invoiceAddressId: number;
	invoiceAddressName: string;
	invoiceAddressPhone: string | null | undefined;
	invoiceAddressPostalCode: string;
	isClosed: boolean;
	lastUpdated: IsoDateTimeString;
	loseReason: string;
	lostAt: IsoDateTimeString | null | undefined;
	note: string;
	offeredAt: IsoDateTimeString | null | undefined;
	orderReference: string;
	paymentTermDesc: string;
	paymentTermId: number;
	plannedDeliveryDate: IsoDateString;
	priceGroupName: string | null | undefined;
	priceRecalculationStatus: CustomerOrderOfferViewPriceRecalculationStatus;
	printedAt: IsoDateTimeString | null | undefined;
	printoutEndText: string;
	printoutStartText: string;
	responsiblePersonEmail: string;
	responsiblePersonId: number;
	responsiblePersonName: string;
	responsiblePersonPhone: string;
	salesCommissionId: number | null | undefined;
	salesLeadId: number | null | undefined;
	salespersonEmail: string | null | undefined;
	salespersonId: number | null | undefined;
	salespersonName: string | null | undefined;
	salespersonPaymentMethod: SalespersonPaymentMethod | null | undefined;
	salespersonPhone: string | null | undefined;
	siteId: number;
	siteName: string;
	transportDuration: number | null | undefined;
	validForDays: number | null | undefined;
	validUntil: IsoDateString | null | undefined;
	vatCodeId: number;
	vatHandlingTypeId: number;
	vatHandlingTypeName: string;
	vatHandlingTypeVatPercent: number | null | undefined;
}
